import * as React from 'react';
import { compose } from 'ramda';
import { connect } from 'react-redux';
import { LinkButton } from '@cian/ui-kit/button';
import { Map16 } from '@cian/ui-kit/icons';
import { IAppState } from '../../../../common/state';
import { getOffersCount } from '../utils/selectors';
import { withEmptyRendering } from '../../../../utils/hoc/withEmptyRendering';
import { SummaryButtonWrapper } from '../../../components/Summary';
import { trackMapViewButtonClicked } from '../utils/tracking';
import { isRedesignExperimentEnabled } from '../../../../selectors/isRedesignExperimentEnabled';

export interface IMapViewButtonProps {
  href: string;
  mapViewAllowed: boolean;
  isRedesignEnabled: boolean;
}

export function MapViewButton({ href, isRedesignEnabled }: IMapViewButtonProps) {
  return (
    <SummaryButtonWrapper>
      <LinkButton
        href={href}
        target="_blank"
        size="XS"
        theme={isRedesignEnabled ? 'fill_white_primary' : 'fill_secondary'}
        beforeIcon={<Map16 color="primary_100" />}
        onClick={trackMapViewButtonClicked}
      >
        На карте
      </LinkButton>
    </SummaryButtonWrapper>
  );
}

export function mapStateToProps(state: IAppState): IMapViewButtonProps {
  const {
    results: { queryString, jsonQuery },
  } = state;
  const offerCount = getOffersCount(state);

  return {
    href: `/map/${queryString ? `?${queryString}` : ''}`,
    mapViewAllowed: offerCount > 0 && !('coworking_offer_type' in jsonQuery),
    isRedesignEnabled: isRedesignExperimentEnabled(state),
  };
}

export function shouldHideContainer(props: IMapViewButtonProps) {
  return !props.mapViewAllowed;
}

export const SummaryMapViewButtonContainer = compose(
  connect(mapStateToProps),
  withEmptyRendering(shouldHideContainer),
)(MapViewButton);
